<template>
  <div class="construction">
    <NullData
      text="正在建设中..."
    />
  </div>
</template>

<script>
import NullData from '@/components/NullData'
export default {
  //
  name: 'Construction',
  components: { NullData },
  props: {},
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.construction{
  width: $xr-min-width;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
